export default __webpack_public_path__ + "static/media/monitor.4c86694a.svg";